module.exports = __webpack_public_path__ + "img/logo.3740ab7a.svg";